import React from 'react'
import classnames from 'classnames'
import { Wrapper, LeftWrapper, RightWrapper } from './styles'
import Container from '../Container'

const Content = ({
  left: Left,
  right: Right,
  adjustPageContainerForMenu,
  constrainWidth,
  disableGutter,
  className,
  component = 'div',
  children,
  style,
  animateIn
}) => {
  const hasAsideContent = Left || Right
  return (
    <Wrapper
      hasAsideContent={hasAsideContent}
      className={classnames(className, { animateIn })}
      as={component}
      style={style}
    >
      {hasAsideContent && <LeftWrapper>{Left && <Left />}</LeftWrapper>}
      <Container
        constrainWidth={constrainWidth}
        disableGutter={disableGutter}
        adjustPageContainerForMenu={adjustPageContainerForMenu}
      >
        {children}
      </Container>
      {hasAsideContent && <RightWrapper>{Right && <Right />}</RightWrapper>}
    </Wrapper>
  )
}

export default Content
